import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    DialogContentText,
    DialogActions,
    Typography,
    Box,
} from "@mui/material";
import moment from "moment";
import parse from "html-react-parser";
import axios from "axios";
import { useEffect } from "react";
import config from "../../utils/config";
import headers from "../../utils/headers";

function NotificationDialog({ open, onClose, notification }) {
    useEffect(() => {
        if (notification == null || notification.read) return;

        axios
            .post(`${config.API_ENDPOINT}/notifications/${notification._id}/read`, {}, headers())
            .then(() => notification.read = true)
            .catch(() => {
                // ignore 
            });

    }, [notification]);

    if (notification == null) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle sx={{ pb: 1 }}>{notification.title}</DialogTitle>
            <DialogContent>
                <Typography sx={{ fontSize: 12, mb: 2 }} color="text.secondary">{moment(notification.datetime).format("DD/MM/YYYY HH:mm")}</Typography>
                <DialogContentText component="div" sx={{ color: "text.primary" }}>
                    <Box sx={{ lineHeight: 1.6 }}>{parse(notification.message)}</Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" sx={{ textTransform: "none", fontWeight: 600 }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NotificationDialog;